/**
 * Короткий підпис власника карти (Mono ФОП) у таблицях.
 * Якщо кілька ФОП мають той самий прізвище (за profile.lastName з /api/users/fops),
 * першим у сортуванні за ім'ям показуємо прізвище, решті — ім'я, щоб розрізняти картки.
 */
function norm(s) {
    return String(s || "")
        .trim()
        .toLocaleLowerCase("uk");
}

/** Як у старому CardLabel: лише друге слово, коли заголовок з 4 токенів (наприклад префікс + ПІБ). */
function legacyHolderText(fullText) {
    const parts = String(fullText || "")
        .trim()
        .replace(/\s+/g, " ")
        .split(/\s+/);
    return parts.length === 4 ? parts[1] : fullText;
}

/**
 * @param {string} slug
 * @param {Record<string, string>} labelBySlug
 * @param {Record<string, { firstName?: string, lastName?: string }>} metaBySlug
 */
export function pickFopCardHolderShortLabel(slug, labelBySlug, metaBySlug) {
    if (!slug) return "";

    const fullText = (labelBySlug && labelBySlug[slug]) || slug;
    const meta = (metaBySlug && metaBySlug[slug]) || {};
    const last = norm(meta.lastName);
    const first = (meta.firstName || "").trim();

    if (!metaBySlug || !last) {
        return legacyHolderText(fullText);
    }

    const sameLast = [];
    for (const s of Object.keys(metaBySlug)) {
        const m = metaBySlug[s];
        if (norm(m?.lastName) === last) sameLast.push(s);
    }

    if (sameLast.length < 2) {
        return legacyHolderText(fullText);
    }

    const sorted = sameLast
        .map((s) => ({
            slug: s,
            first: ((metaBySlug[s] && metaBySlug[s].firstName) || "").trim(),
            lastRaw: ((metaBySlug[s] && metaBySlug[s].lastName) || "").trim(),
        }))
        .sort((a, b) =>
            (a.first || "\uFFFF").localeCompare(b.first || "\uFFFF", "uk")
        );

    const idx = sorted.findIndex((row) => row.slug === slug);
    if (idx < 0) {
        return legacyHolderText(fullText);
    }

    if (idx === 0) {
        const show = sorted[idx].lastRaw;
        return show || legacyHolderText(fullText);
    }

    return first || legacyHolderText(fullText);
}
